import React, { createContext, useState, useEffect } from 'react';
import api from '../api/client';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true); // Add this!

 useEffect(() => {
  const syncUser = async () => {
    // ✅ Skip the API call entirely if no token exists
    const token = localStorage.getItem('X-Auth-Token');
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const response = await api.get('/users/me');
      if (response.data) {
        setCurrentUser(response.data);
        localStorage.setItem('user', JSON.stringify(response.data));
      }
    } catch (err) {
      console.log('No active session found');
      setCurrentUser(null);
      localStorage.removeItem('user');
      if (err.response?.status === 401) {
    localStorage.removeItem('X-Auth-Token');
  }
    } finally {
      setLoading(false);
    }
  };

  syncUser();
}, []);

  return (
    <AuthContext.Provider value={{ currentUser, setCurrentUser, authLoading: loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;